import { React, useContext, useEffect, useState } from 'react'
import { CButton, CModal, CModalBody, CModalFooter } from '@coreui/react'
import TemplateAccordion from 'src/components/template/templateAccordion'
import { getThumbnail, masterAndChildIntersection, validateLink } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import { AppContext } from 'src/views/context/app'
import Loading from 'react-fullscreen-loading'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import { isEmpty } from 'lodash'
import AddIcon from '../../../assets/addnew-icon1.svg'
import FormFieldModal from './formFieldModal'
import ToggleButtons from 'src/components/toggleButtons/toggleButtons'
import FormAttachLink from './formAttachLink'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API, USER_API } from 'src/views/utils/urls'
import CustomMultiSelectValues from '../../../components/customMultiSelect/customMultiSelectValues'

const FormModal = ({ data, formName, onSave, onCancel }) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)
  const fieldTypeNameObj = {
    TEXT_INPUT: 'Text Input',
    TEXT_AREA: 'Text Area Box',
    DROPDOWN: 'Drop-down',
    EMAIL: 'Email',
    PHONE: 'Phone',
  }
  const [imageS3key, setImageS3key] = useState('')
  const [heading, setHeading] = useState('')
  const [subHeading, setSubHeading] = useState('')
  const [imageData, setImageData] = useState([])
  const [fieldsData, setFieldsData] = useState([])
  const [fieldModal, setFieldModal] = useState(false)

  const [isMinimised, setIsMinimised] = useState(false)
  const [minimizeApplicable, setMinimizeApplicable] = useState(false)
  const [sendEmailNotification, setSendEmailNotification] = useState(false)
  const [sendFormDataEmail, setSendFormDataEmail] = useState(false)
  const [leadOwners, setLeadOwners] = useState([])
  const [leadPartnerMaster, setLeadPartnerMaster] = useState([])
  const [isLoginRequired, setIsLoginRequired] = useState(false)
  const [entities, setEntities] = useState({})

  const [buttonText, setButtonText] = useState('Submit')
  const [errorData, setErrorData] = useState({})

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  const [{ data: leadPartnerList }] = useAxios({
    url: `${USER_API}/lead-partner`,
    method: 'get',
  })

  useEffect(() => {
    if (leadPartnerList && leadPartnerList.success) {
      let tempPartner = []
      leadPartnerList.data.forEach((element) => {
        let obj = element
        obj[`displayName`] = `${element.name}(${element.email_id})`
        tempPartner.push(obj)
      })
      const leadPartnerMasterData = tempPartner.filter((info) => info.status)
      setLeadPartnerMaster(leadPartnerMasterData)
      if (data?.lead_owners) {
        let tempOwner = []
        data?.lead_owners.forEach((partnerId) => {
          console.log('partnerId', partnerId)
          const partnerObj = leadPartnerMasterData.find((info) => info._id === partnerId)
          if (partnerObj) {
            tempOwner.push(partnerObj)
          }
        })
        console.log('tempOwner', tempOwner)
        setLeadOwners(masterAndChildIntersection(leadPartnerMasterData, tempOwner))
      }
    }
  }, [leadPartnerList])

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'img',
        width: 245,
        height: 138,
        divwidth: '13.9375rem',
        divheight: '7.1875rem',
        assetId: '',
        setAssetId: (id) => {
          setImageS3key(id)
        },
        setImage: (obj) => {
          //   setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        titleDisabled: true,
        uploadIconflexRow: true,
        uploadIconsize: '10px',
        btnMarginTop: '7px',
      },
    ]

    if (!isEmpty(data)) {
      setHeading(data?.heading)
      setSubHeading(data?.sub_heading)
      setImageS3key(data?.thumbnail?._id)

      setFieldsData(data?.fields?.data)

      setIsMinimised(data?.is_minimised)
      setIsLoginRequired(data?.is_login_required)
      setSendFormDataEmail(data?.send_form_data_email)
      setSendEmailNotification(data?.send_email_notification)
      setMinimizeApplicable(data?.minimize_applicable)
      setEntities(data?.entities)

      setButtonText(data?.button_text)

      imgData[0]['assetId'] = data?.thumbnail?.s3_key
      imgData[0]['imageUrl'] = getThumbnail(
        userSessionObj?.session_data?.cf_domain_name,
        data?.thumbnail?.s3_key,
      )
    }
    setImageData(imgData)
  }, [data])

  const validateInfo = () => {
    let temp = {}
    let isFormValid = true

    if (heading.trim().length === 0) {
      isFormValid = false
      temp.heading = 'heading cannot be empty!'
    }

    if (fieldsData.length === 0) {
      isFormValid = false
      temp.fieldsData = 'Fields cannot be empty!'
    }

    if (isEmpty(entities)) {
      isFormValid = false
      temp.entities = 'Please specify Placement!'
    }

    if (entities?.type && !validateLink(entities).isValid) {
      isFormValid = false
      temp.entities = validateLink(entities).error
    }

    if (buttonText.trim().length === 0) {
      isFormValid = false
      temp.buttonText = 'Button text cannot be empty!'
    }

    setErrorData({ ...temp })

    return isFormValid
  }

  const onSaveHandler = async () => {
    if (!validateInfo()) return

    let payload = {
      heading: heading,
      sub_heading: subHeading,
      fields: { data: fieldsData },
      thumbnail: imageS3key,
      entities: entities,
      is_login_required: isLoginRequired,
      is_minimised: isMinimised,
      minimize_applicable: minimizeApplicable,
      send_email_notification: sendEmailNotification,
      send_form_data_email: sendFormDataEmail,
      lead_owners: leadOwners.map((item) => item._id),
      button_text: buttonText,
    }

    if (isEmpty(data)) {
      payload['name'] = formName
    }

    onSave(payload)
  }
  const onFieldsSaveHandler = (value) => {
    setErrorData((prev) => ({ ...prev, fieldsData: '' }))
    setFieldsData((prev) => [...prev, value])
    setFieldModal(false)
  }

  const onChangeLeadOwner = (val) => {
    setLeadOwners(val)
    if (isEmpty(val)) {
      sendFormDataEmail(false)
      sendEmailNotification(false)
    }
  }

  let accordionItems = [
    {
      title: 'Add Image and Headings',
      description:
        'Specify the image, Heading and Sub-header which you would like to display on the form.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5' }}
          className=" px-3 pt-2 pb-3 d-flex justify-content-center align-items-center"
        >
          <div style={{ width: '34.3%' }} className="d-flex flex-col justify-content-between ">
            <h6 style={{ fontSize: '13px' }} className="mb-1">
              Image
            </h6>
            <ImageUploader data={imageData} />
            <span className="mt-1 text-center" style={{ fontSize: '11px', color: '#707070' }}>
              Image size: 270 px X 138 px
            </span>
          </div>
          <div style={{ width: '61%' }} className="d-flex flex-col justify-content-between">
            <div className="">
              <h6 style={{ fontSize: '13px' }} className="">
                Heading <span style={{ color: 'red' }}>*</span>
              </h6>
              <CustomDescriptionBox
                limit={30}
                rows={1}
                value={heading}
                onChange={(value) => setHeading(value)}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
                isMandatory={true}
                errorText={errorData.heading}
              />
            </div>
            <div className="">
              <h6 style={{ fontSize: '13px' }} className="">
                Sub-Heading
              </h6>
              <CustomDescriptionBox
                limit={45}
                rows={1}
                value={subHeading}
                onChange={(value) => setSubHeading(value)}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
              />
            </div>
          </div>
        </div>
      ),
      itemStyle: '',
    },
    {
      title: 'Add Fields',
      description: `Specify the blank fields/space you'd like to show on the form.`,
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5', height: '240px' }}
          className=" pt-2 pb-3 d-flex justify-content-center position-relative"
        >
          <div className="  w-100 d-flex justify-content-center  align-items-center">
            <div
              className="d-flex px-2 mt-2 justify-content-center align-items-center bg-black text-white position-absolute"
              style={{
                fontSize: 'max(0.63vw,10px)',
                // gap: '0 2.2%',
                paddingTop: '2px',
                paddingBottom: '2px ',
                top: '0',
                zIndex: '10',
                width: '92%',
                borderRadius: '2px',
              }}
            >
              <div style={{ width: '100%' }} className="d-flex align-items-center">
                <div style={{ marginBlockEnd: '0', width: '50%' }}>Field name</div>
                <div style={{ marginBlockEnd: '0', width: '28%' }}>Field Type</div>
                <div style={{ marginBlockEnd: '0', width: '22%' }}>Mandatory</div>
              </div>
            </div>
            <div
              className="static-scrollbar-class mt-5"
              style={{
                width: '92%',
                height: '90%',
              }}
            >
              {!isEmpty(fieldsData) &&
                fieldsData.map((info, idx) => {
                  return (
                    <div
                      style={{
                        width: '100%',
                        aspectRatio: '65/3',
                        boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                        display: 'flex',
                        background: '#f6f6f6',
                        fontSize: '14px',
                      }}
                      key={idx}
                      className={`rounded-1 ${
                        idx && 'mt-2'
                      }  d-flex px-2  justify-content-center align-items-center`}
                    >
                      <div style={{ width: '100%' }} className="d-flex align-items-center">
                        <div
                          style={{ marginBlockEnd: '0', width: '50%', fontWeight: '550' }}
                          className="line-clamp-1"
                        >
                          {info.name}
                        </div>
                        <div style={{ marginBlockEnd: '0', width: '28%' }}>
                          {fieldTypeNameObj[info.type]}
                        </div>
                        <div style={{ marginBlockEnd: '0', width: '20.5%' }}>
                          {info.is_mandatory ? 'Yes' : 'No'}
                        </div>
                      </div>
                    </div>
                  )
                })}
              <div
                style={{
                  width: '100%',
                  aspectRatio: '65/3',
                  boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                  display: 'flex',
                  background: '#f6f6f6',
                  fontSize: '14px',
                  fontWeight: 550,
                }}
                className={`rounded-1 mt-2 cursor-pointer d-flex  justify-content-center align-items-center`}
                onClick={() => setFieldModal(true)}
              >
                <img src={AddIcon} style={{ width: '24px', height: '24px' }} />
                Add New Field
              </div>
              <div className="message-text error-message">
                <p>{errorData.fieldsData}</p>
              </div>
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Specify Form Placement & Behaviour',
      description: 'Specify the default behaviour and  placement of your form across the platform.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5', height: '280px' }}
          className=" px-3 pt-2 pb-3 d-flex flex-col  align-items-center"
        >
          <div className="d-flex justify-content-between align-items-center w-100 mt-3">
            <div
              className="d-flex justify-content-between align-items-center "
              style={{ width: '52.7%' }}
            >
              <h6 style={{ fontSize: '14px' }} className="mb-0">
                Minimisation Applicable :
              </h6>
              <ToggleButtons
                toggle={minimizeApplicable}
                setToggle={(value) => {
                  setMinimizeApplicable(value)
                  setIsMinimised(value)
                }}
                trueOption={'Yes'}
                falseOption={'No'}
                toggleWidth="52%"
              />
            </div>
            {minimizeApplicable && (
              <div
                className="d-flex justify-content-between align-items-center "
                style={{ width: '43.7%' }}
              >
                <h6 style={{ fontSize: '14px' }} className="mb-0">
                  Default Behaviour :
                </h6>
                <ToggleButtons
                  toggle={isMinimised}
                  setToggle={(value) => setIsMinimised(value)}
                  trueOption={'Minimize'}
                  falseOption={'Open'}
                  toggleWidth="52%"
                />
              </div>
            )}
          </div>

          <div className="d-flex justify-content-between align-items-center w-100 mt-3">
            <div
              className="d-flex justify-content-between align-items-center "
              style={{ width: '52.7%' }}
            >
              <h6 style={{ fontSize: '14px' }} className="mb-0">
                Sign-in Required :
              </h6>
              <ToggleButtons
                toggle={isLoginRequired}
                setToggle={setIsLoginRequired}
                trueOption={'Yes'}
                falseOption={'No'}
                toggleWidth="52%"
              />
            </div>
          </div>
          <div className="w-100 h-100 mt-2 ">
            <FormAttachLink
              linkData={entities}
              id={'entities'}
              categoryData={
                categoryList
                  ? categoryList?.data.filter(
                      (info, idx) => info.type === 'category' && info.status,
                    )
                  : []
              }
              setLinkData={(value) => {
                console.log('FormAttachLink', value)
                setErrorData((prev) => ({ ...prev, entities: '' }))
                setEntities(value)
              }}
            />
            <div className="message-text error-message">
              <p>{errorData.entities}</p>
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Lead Partner',
      description: 'Select Lead Partner if applicable',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-3 pt-2 pb-3">
          {!isEmpty(leadPartnerMaster) && (
            <div className="w-100">
              <div>
                <CustomMultiSelectValues
                  selectedValue={leadOwners}
                  optionsData={leadPartnerMaster}
                  onChange={onChangeLeadOwner}
                  dropDownlabelKey="email_id"
                  tileLabelKey="name"
                />
              </div>
            </div>
          )}

          {!isEmpty(leadOwners) && (
            <div className="d-flex justify-content-between align-items-center w-100 mt-3">
              <div
                className="d-flex justify-content-between align-items-center "
                style={{ width: '52.7%' }}
              >
                <h6 style={{ fontSize: '14px' }} className="mb-0">
                  Send Email Notification :
                </h6>
                <ToggleButtons
                  toggle={sendEmailNotification}
                  setToggle={(value) => {
                    setSendEmailNotification(value)
                    setSendFormDataEmail(value ? sendFormDataEmail : false)
                  }}
                  trueOption={'Yes'}
                  falseOption={'No'}
                  toggleWidth="52%"
                />
              </div>
              {sendEmailNotification && (
                <div
                  className="d-flex justify-content-between align-items-center "
                  style={{ width: '43.7%' }}
                >
                  <h6 style={{ fontSize: '14px' }} className="mb-0">
                    Form Data In Email :
                  </h6>
                  <ToggleButtons
                    toggle={sendFormDataEmail}
                    setToggle={(value) => setSendFormDataEmail(value)}
                    trueOption={'Yes'}
                    falseOption={'No'}
                    toggleWidth="52%"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'CTA Button Text',
      description: 'Mention the text on the CTA button of the form.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5' }}
          className=" px-3 pt-2 pb-3 d-flex justify-content-center  align-items-center"
        >
          <div className="w-100">
            <div className="">
              <h6 style={{ fontSize: '13px' }} className="">
                Button Text
              </h6>
              <CustomDescriptionBox
                limit={16}
                rows={1}
                value={buttonText}
                onChange={(value) => setButtonText(value)}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
                isMandatory={true}
                errorText={errorData.buttonText}
              />
            </div>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
  ]

  return (
    <>
      <CModal
        size="lg"
        scrollable
        visible={true}
        alignment="center"
        className="custom-form-modal border-0"
      >
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <div
          className="px-5 text-white w-100 d-flex align-items-center"
          style={{ height: '3.8vw', backgroundImage: 'linear-gradient(to bottom, #646464, #111)' }}
        >
          <p style={{ fontSize: '1.5625vw' }} className="mb-0">
            Custom Form Details
          </p>
        </div>
        <CModalBody
          style={{ height: '60vh' }}
          className="m-auo p-0 rounded-sm static-scrollbar-class"
        >
          <div className="d-flex justify-content-center px-5 mt-4">
            <div className="flex flex-column justify-content-center align-items-center w-100">
              <TemplateAccordion items={accordionItems} styles={''} />
            </div>
          </div>
        </CModalBody>

        <CModalFooter className="p-0 px-5 border-0">
          <span className="mt-2 w-100" style={{ fontSize: '10.5px' }}>
            <span style={{ color: 'red' }}>*</span> Atleast one field is required to create a custom
            form.
          </span>
          <div className="d-flex justify-content-end w-100  mb-4">
            <CButton
              style={{ color: 'black', border: '1px solid black', fontSize: '.9vw' }}
              className="mr-5 bg-white rounded-1 btn-focus-none px-4"
              type="submit"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton
              style={{ border: '1px solid black', fontSize: '.9vw' }}
              className="ml-2 bg-black rounded-1 btn-focus-none px-4"
              type="submit"
              onClick={onSaveHandler}
            >
              Save
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
      {fieldModal && (
        <FormFieldModal
          onCancel={() => setFieldModal(false)}
          onSave={(value) => {
            onFieldsSaveHandler(value)
          }}
        />
      )}
    </>
  )
}

export default FormModal
